import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { useMaxWidthTabletLarge } from '../../hooks/useMediaQueries';
import {
  setActiveSpot,
  clearActiveSpot,
  setSpotListScrollPosition,
} from '../../actions/animations';
import mapPropType from '../../propTypes/map';
import unitsPropType from '../../propTypes/units';
import animationsPropType from '../../propTypes/animations';
import scrollPositionPropType from '../../propTypes/animations/scrollPosition';
import SpotList from '../../components/SpotList';
import MotionScrollWrapper from '../../components/MotionScrollWrapper';
import { getSpotListScrollPosition } from '../../selectors/animations';
import locationViewPropShape from '../../propTypes/locationView';

const SpotListContainer = ({
  map,
  units,
  animations,
  spotListScrollPosition,
  doSetActiveSpot,
  doClearActiveSpot,
  doSetScrollPosition,
  locationView = null,
}) => {
  const isMobileView = useMaxWidthTabletLarge();

  return (
    <div>
      <MotionScrollWrapper scrollPosition={spotListScrollPosition}>
        <SpotList
          locationView={locationView}
          spots={map.spots}
          subregions={map.subregions}
          units={units}
          animations={animations}
          isMobileView={isMobileView}
          doSetActiveSpot={doSetActiveSpot}
          doSetScrollPosition={doSetScrollPosition}
          doClearActiveSpot={doClearActiveSpot}
        />
      </MotionScrollWrapper>
    </div>
  );
};

SpotListContainer.propTypes = {
  map: mapPropType.isRequired,
  units: unitsPropType.isRequired,
  animations: animationsPropType.isRequired,
  spotListScrollPosition: scrollPositionPropType.isRequired,
  doSetActiveSpot: PropTypes.func.isRequired,
  doClearActiveSpot: PropTypes.func.isRequired,
  doSetScrollPosition: PropTypes.func.isRequired,
  locationView: locationViewPropShape,
};

export default connect(
  (state) => ({
    map: state.map,
    units: state.units,
    animations: state.animations,
    spotListScrollPosition: getSpotListScrollPosition(state),
  }),
  (dispatch) => ({
    doSetActiveSpot: (spotId) => dispatch(setActiveSpot(spotId)),
    doClearActiveSpot: () => dispatch(clearActiveSpot()),
    doSetScrollPosition: (scrollPosition) => dispatch(setSpotListScrollPosition(scrollPosition)),
  }),
)(SpotListContainer);
